module.exports = __webpack_public_path__ + "img/sauna.31cd4413.jpg";